import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAccountBilling } from 'hooks/billing/useAccountBilling';
import { useSelfServeGate } from 'hooks/billing/useSelfServeGate';
import { Loader } from 'components/Loader';
import { ROUTES } from '../consts';

/**
 * Guards the billing "Manage subscription" tab. Only self-serve billing admins
 * (canPurchase) who are NOT in an active trial can see the tab content.
 * Trial users see the tab as disabled in the UI (OverviewTabs) and are
 * redirected here so the route and the tab stay in sync.
 * Non-purchasers and enterprise users are also redirected to analytics.
 */
export const ManageSubscriptionProtectedRoute = ({
  children,
}: PropsWithChildren) => {
  const { canPurchase, isLoading } = useSelfServeGate();
  const { isAccountInTrial } = useAccountBilling();

  if (isLoading) {
    return <Loader center />;
  }

  const shouldRedirectToAnalytics = !canPurchase || isAccountInTrial;

  if (shouldRedirectToAnalytics) {
    return <Navigate to={ROUTES.BILLING_ANALYTICS} replace />;
  }

  return <>{children}</>;
};
